module.exports = __webpack_public_path__ + "static/media/nt.a4739b60.svg";